import { PolicyManagementRecord } from "entities/UIModel/PolicyManagementRecord";
import { StageType } from "utils/data/enum";

// Temporary mock data for UI development — the Deleted Records backend
// (querying by the IsDeleted flag / RestorePolicyTransactionBatch) doesn't
// exist yet. Remove once the real API is wired up.
export const DUMMY_DELETED_RECORDS: PolicyManagementRecord[] = [
  {
    uniqueIdentifier: "9001",
    PolicyTransactionID: 9001,
    IdentityKey: 9001,
    PolicyNumber: "PN-100234",
    AgentID: "AG-4521",
    ReportingID: "RPT-7781",
    StateAbbr: "TX",
    CountyDisplayName: "Travis",
    MunicipalityNum: "0512",
    IsHOI: true,
    OriginalPolicyNumber: "OPN-990011",
    PolicyFormName: "ALTA Owner's Policy",
    ProductTypeAbbrTypeName: "Owner Policy",
    ReceivedDate: "2026-08-01T00:00:00",
    EffectiveDate: "2026-08-05T00:00:00",
    FileNumber: "FN-55231",
    FormPrefix: "OP",
    TransCode: "REG",
    RecordTypeName: "In Lieu Of",
    PropertyTypeName: "Residential",
    BookedTypeName: "Reported",
    OpenErrorCount: 0,
    LiabilityAmount: 425000,
    OriginalRemitSplitPct: 70,
    NewRemitSplitPct: 70,
    IsDeleted: true,
    OriginalQueueCode: StageType.QUALITYREVIEW,
    OriginalQueueName: "Quality Review",
    DeletedByUserName: "jsmith",
    DeletedDate: "2026-09-10T00:00:00",
    DeletedReason: "Duplicate entry from register upload",
  },
  {
    uniqueIdentifier: "9002",
    PolicyTransactionID: 9002,
    IdentityKey: 9002,
    PolicyNumber: "PN-100235",
    AgentID: "AG-4522",
    ReportingID: "RPT-7782",
    StateAbbr: "FL",
    CountyDisplayName: "Miami-Dade",
    MunicipalityNum: "0223",
    IsHOI: false,
    OriginalPolicyNumber: "OPN-990012",
    PolicyFormName: "ALTA Loan Policy",
    ProductTypeAbbrTypeName: "Loan Policy",
    ReceivedDate: "2026-08-03T00:00:00",
    EffectiveDate: "2026-08-06T00:00:00",
    FileNumber: "FN-55232",
    FormPrefix: "LP",
    TransCode: "SI",
    RecordTypeName: "Adjustment",
    PropertyTypeName: "Commercial",
    BookedTypeName: "Calculated",
    OpenErrorCount: 1,
    LiabilityAmount: 812000,
    OriginalRemitSplitPct: 65,
    NewRemitSplitPct: 65,
    IsDeleted: true,
    OriginalQueueCode: StageType.PRECLOSE,
    OriginalQueueName: "Pre-Close",
    DeletedByUserName: "mgarcia",
    DeletedDate: "2026-09-11T00:00:00",
    DeletedReason: "Incorrect agent assignment",
  },
  {
    uniqueIdentifier: "9003",
    PolicyTransactionID: 9003,
    IdentityKey: 9003,
    PolicyNumber: "PN-100236",
    AgentID: "AG-4523",
    ReportingID: "RPT-7783",
    StateAbbr: "CA",
    CountyDisplayName: "Orange",
    MunicipalityNum: "0088",
    IsHOI: true,
    OriginalPolicyNumber: "OPN-990013",
    PolicyFormName: "CLTA Binder",
    ProductTypeAbbrTypeName: "Binder",
    ReceivedDate: "2026-08-07T00:00:00",
    EffectiveDate: "2026-08-10T00:00:00",
    FileNumber: "FN-55233",
    FormPrefix: "BD",
    TransCode: "REG",
    RecordTypeName: "Void",
    PropertyTypeName: "Vacant Land",
    BookedTypeName: "Reported",
    OpenErrorCount: 0,
    LiabilityAmount: 156500,
    OriginalRemitSplitPct: 80,
    NewRemitSplitPct: 75,
    IsDeleted: true,
    OriginalQueueCode: StageType.QUALITYREVIEW,
    OriginalQueueName: "Quality Review",
    DeletedByUserName: "jsmith",
    DeletedDate: "2026-09-12T00:00:00",
    DeletedReason: "Test record cleanup",
  },
  {
    uniqueIdentifier: "9004",
    PolicyTransactionID: 9004,
    IdentityKey: 9004,
    PolicyNumber: "PN-100237",
    AgentID: "AG-4524",
    ReportingID: "RPT-7784",
    StateAbbr: "TX",
    CountyDisplayName: "Harris",
    MunicipalityNum: "0777",
    IsHOI: false,
    OriginalPolicyNumber: "OPN-990014",
    PolicyFormName: "ALTA Owner's Policy",
    ProductTypeAbbrTypeName: "Owner Policy",
    ReceivedDate: "2026-08-09T00:00:00",
    EffectiveDate: "2026-08-12T00:00:00",
    FileNumber: "FN-55234",
    FormPrefix: "OP",
    TransCode: "ADJ",
    RecordTypeName: "Cancel",
    PropertyTypeName: "Residential",
    BookedTypeName: "Reported",
    OpenErrorCount: 2,
    LiabilityAmount: 298750,
    OriginalRemitSplitPct: 70,
    NewRemitSplitPct: 70,
    IsDeleted: true,
    OriginalQueueCode: StageType.PRECLOSE,
    OriginalQueueName: "Pre-Close",
    DeletedByUserName: "kwilliams",
    DeletedDate: "2026-09-13T00:00:00",
    DeletedReason: "Superseded by corrected transaction",
  },
  {
    uniqueIdentifier: "9005",
    PolicyTransactionID: 9005,
    IdentityKey: 9005,
    PolicyNumber: "PN-100238",
    AgentID: "AG-4525",
    ReportingID: "RPT-7785",
    StateAbbr: "AZ",
    CountyDisplayName: "Maricopa",
    MunicipalityNum: "0341",
    IsHOI: true,
    OriginalPolicyNumber: "OPN-990015",
    PolicyFormName: "ALTA Loan Policy",
    ProductTypeAbbrTypeName: "Loan Policy",
    ReceivedDate: "2026-08-14T00:00:00",
    EffectiveDate: "2026-08-18T00:00:00",
    FileNumber: "FN-55235",
    FormPrefix: "LP",
    TransCode: "REG",
    RecordTypeName: "In Lieu Of",
    PropertyTypeName: "Commercial",
    BookedTypeName: "Calculated",
    OpenErrorCount: 0,
    LiabilityAmount: 540000,
    OriginalRemitSplitPct: 72,
    NewRemitSplitPct: 72,
    IsDeleted: true,
    OriginalQueueCode: StageType.QUALITYREVIEW,
    OriginalQueueName: "Quality Review",
    DeletedByUserName: "mgarcia",
    DeletedDate: "2026-09-14T00:00:00",
    DeletedReason: "Duplicate entry from register upload",
  },
] as PolicyManagementRecord[];
